import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import { getValueForClientSize } from 'utils/bolt';
import { useDynamicAssetFolder } from 'utils/assets';
import * as webp from 'utils/bolt/webp';
import s from 'components/bolt/sectionLoader/spinner.sss';

export default class Spinner extends Component {
	render(props, { ttLoaded }) {
		const { appData, onlySpinner, class: extraClass } = props;
		const accessibilityCopy = appData?.copy?.accessibilityCopy || {};
		const tt = appData?.header?.powsterHeader?.tt;
		const fallbackFormat = appData?.header?.alternativeImageFormat || 'png';

		return (
			<div class={joinClasses(extraClass, s.container, onlySpinner && s.centered)}>
				{!onlySpinner && tt && (
					<webp.Picture
						style={{ display: ttLoaded ? 'block' : 'none' }}
						class={s.tt}
						key="tt"
						alt={accessibilityCopy[tt.alt] || tt.alt}
						src={useDynamicAssetFolder(getValueForClientSize(tt))}
						fallbackFormat={fallbackFormat}
						onLoad={() => this.setState({ ttLoaded: true })}
					/>
				)}
				<div class={s.ring} key="spinner" />
			</div>
		);
	}
}
